import _ from 'lodash'
import { getType, Reducer } from 'typesafe-actions'

import { withLoadingReducer } from '../../../redux/loading'

import { ImportCheckProductsActions } from './actions'
import { ImportProductsState as ImportCheckProductsState, Product } from './types'

export const initialState: ImportCheckProductsState = {
  data: { items: [], isItemWithNoResults: false, isItemWithOnlineReport: false, allEnabled: false },
  page: 1,
  totalPages: 1
}

export const reducer: Reducer<ImportCheckProductsState, ImportCheckProductsActions> = (
  state = initialState,
  action
): ImportCheckProductsState => {
  switch (action.type) {
    case getType(ImportCheckProductsActions.fetchData): {
      return {
        ...state,
        data:
          action.payload.importId && state.importId && action.payload.importId !== state.importId
            ? initialState.data
            : state.data,
        importId: action.payload.importId ?? state.importId,
        page: action.payload.page
      }
    }
    case getType(ImportCheckProductsActions.setData): {
      return {
        ...state,
        data: action.payload.data,
        page: action.payload.page,
        totalPages: action.payload.totalPages
      }
    }
    case getType(ImportCheckProductsActions.setEnabled): {
      return {
        ...state,
        data: {
          ...state.data,
          items: _.map(state.data.items, i => ({
            ...i,
            enabled: action.payload.itemId === i.id ? action.payload.enabled : i.enabled
          })),
          allEnabled: !action.payload.enabled ? false : state.data.allEnabled
        }
      }
    }
    case getType(ImportCheckProductsActions.setAllEnabled): {
      return {
        ...state,
        data: {
          ...state.data,
          items: _.map(state.data.items, i => ({
            ...i,
            enabled:
              action.payload.enabled &&
              (_.size(i.searches) > 0 || _.size(_.keys(_.omit(i.investigation, 'products'))) > 0)
          })),
          allEnabled: action.payload.enabled
        }
      }
    }
    case getType(ImportCheckProductsActions.selectReport): {
      return {
        ...state,
        data: {
          ...state.data,
          items: _.map(state.data.items, i =>
            action.payload.itemId === i.id
              ? {
                  ...i,
                  investigation: i.investigation?.products
                    ? {
                        ...i.investigation,
                        products: _.map(i.investigation.products, (p: Product) =>
                          p.enabled === (action.payload.reportCode === p.code) ? p : { ...p, enabled: !p.enabled }
                        )
                      }
                    : i.investigation,
                  searches: _.map(i.searches, s =>
                    s.companyIdentifier === action.payload.companyIdentifier
                      ? {
                          ...s,
                          products: _.map(s.products, (p: Product) =>
                            p.enabled === (action.payload.reportCode === p.code) ? p : { ...p, enabled: !p.enabled }
                          )
                        }
                      : s
                  )
                }
              : i
          )
        }
      }
    }
    case getType(ImportCheckProductsActions.selectDeliveryOption): {
      return {
        ...state,
        data: {
          ...state.data,
          items: _.map(state.data.items, i =>
            action.payload.itemId === i.id
              ? {
                  ...i,
                  investigation: i.investigation?.products
                    ? {
                        ...i.investigation,
                        products: _.map(i.investigation.products, (p: Product) =>
                          p.code === action.payload.reportCode
                            ? {
                                ...p,
                                deliveryOptions: _.map(p.deliveryOptions, dOpt =>
                                  dOpt.enabled === (action.payload.deliveryOptionCode === dOpt.code)
                                    ? dOpt
                                    : { ...dOpt, enabled: !dOpt.enabled }
                                )
                              }
                            : p
                        )
                      }
                    : i.investigation,
                  searches: _.map(i.searches, s =>
                    s.companyIdentifier === action.payload.companyIdentifier
                      ? {
                          ...s,
                          products: _.map(s.products, (p: Product) =>
                            p.code === action.payload.reportCode
                              ? {
                                  ...p,
                                  deliveryOptions: _.map(p.deliveryOptions, dOpt =>
                                    dOpt.enabled === (action.payload.deliveryOptionCode === dOpt.code)
                                      ? dOpt
                                      : { ...dOpt, enabled: !dOpt.enabled }
                                  )
                                }
                              : p
                          )
                        }
                      : s
                  )
                }
              : i
          )
        }
      }
    }
    case getType(ImportCheckProductsActions.selectReportLanguage): {
      return {
        ...state,
        data: {
          ...state.data,
          items: _.map(state.data.items, i =>
            action.payload.itemId === i.id
              ? {
                  ...i,
                  investigation: i.investigation?.products
                    ? {
                        ...i.investigation,
                        products: _.map(i.investigation.products, (p: Product) =>
                          p.code === action.payload.reportCode
                            ? {
                                ...p,
                                languages: _.mapValues(
                                  p.languages,
                                  (_value, key) => key === action.payload.reportLanguageCode
                                )
                              }
                            : p
                        )
                      }
                    : i.investigation,
                  searches: _.map(i.searches, s =>
                    s.companyIdentifier === action.payload.companyIdentifier
                      ? {
                          ...s,
                          products: _.map(s.products, (p: Product) =>
                            p.code === action.payload.reportCode
                              ? {
                                  ...p,
                                  languages: _.mapValues(
                                    p.languages,
                                    (_value, key) => key === action.payload.reportLanguageCode
                                  )
                                }
                              : p
                          )
                        }
                      : s
                  )
                }
              : i
          )
        }
      }
    }
    case getType(ImportCheckProductsActions.setInvestigation): {
      return {
        ...state,
        data: {
          ...state.data,
          items: _.map(state.data.items, i =>
            action.payload.itemId === i.id
              ? {
                  ...i,
                  investigation: {
                    ...i.investigation,
                    address: action.payload.investigation.address,
                    city: action.payload.investigation.city,
                    companyContact: action.payload.investigation.companyContact,
                    companyName: action.payload.investigation.companyName,
                    country: action.payload.investigation.country,
                    email: action.payload.investigation.email,
                    note: action.payload.investigation.note,
                    phone: action.payload.investigation.phone,
                    postalCode: action.payload.investigation.postalCode,
                    registrationNumbers: action.payload.investigation.registrationNumbers,
                    state: action.payload.investigation.state
                  }
                }
              : i
          )
        }
      }
    }
    default:
      return state
  }
}

export const importCheckProductsReducer = withLoadingReducer(reducer, 'importCheckProducts', initialState)
